import { render, staticRenderFns } from "./disengagedEmployees.vue?vue&type=template&id=2d64c10c&scoped=true"
import script from "./disengagedEmployees.vue?vue&type=script&lang=js"
export * from "./disengagedEmployees.vue?vue&type=script&lang=js"
import style0 from "./disengagedEmployees.vue?vue&type=style&index=0&id=2d64c10c&prod&lang=scss&scoped=true"
import style1 from "./disengagedEmployees.vue?vue&type=style&index=1&id=2d64c10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64c10c",
  null
  
)

export default component.exports